import React from 'react';

const ProjectContext = React.createContext({});

export default ProjectContext;
